<nav #navBarContainer class="main-navbar navbar navbar-expand-md bg-white">
  <div class="main-logo">
    <img src="assets/images/logo-uecko-wardrobe-configurator.svg" alt="{{ 'COMMON.APP_TITLE' | translate }}" width="102">
  </div>

  <ng-template *ngTemplateOutlet="languageSelector; context: { dclass: 'd-block d-md-none' }"></ng-template>

  <button *ngIf="isAuthenticated" class="navbar-toggler" type="button" (click)="toggleNavbars()" aria-label="Toggle navigation">
    <i class="fa-solid fa-ellipsis-vertical"></i>
  </button>

  <div [ngbCollapse]="isNavbarPrimaryCollapsed" [ngClass]="{'justify-content-end' : !isAuthenticated}" class="collapse navbar-collapse main-menu-collapse">
    <div *ngIf="!menu" id="MainMenu-placeholder"></div>
    <ul class="navbar-nav" app-menu *ngIf="menu != null" [items]="menu.Items" [excludedLinkClass]="'admin-menu-link'" id="MainMenu">
    </ul>

    <div class="header-right">

      <ng-template *ngTemplateOutlet="languageSelector; context: { dclass: 'd-none d-md-block' }"></ng-template>

      <div *ngIf="isAuthenticated" class="user-menu-container">
        <button class="usernavbar-toggler d-none d-md-block" type="button" (click)="toggleNavbars(false)" aria-label="Toggle navigation">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </button>
        <div [ngbCollapse]="isNavbarSecondaryCollapsed" class="collapse second-navbar-collapse">
          <!-- Menú admin (elementos con class="admin-menu-link") -->
          <ul class="navbar-nav admin-menu" app-menu *ngIf="menu != null" [items]="menu.Items" [excludedLinkClass]="''" [hasLogout]="true" id="MainAdminMenu" [onNavbarCollapse]="onNavbarCollapse$">
          </ul>
        </div>
      </div>

    </div>
  </div>
</nav>

<ng-template #languageSelector let-dclass="dclass">
  <div class="{{dclass}}">
    <app-language-selector [from]="'header'"></app-language-selector>
  </div>
</ng-template>